<template>
  <el-row class="dialog-content">
    <el-col :lg="9" :md="24" style="padding-right: 4px;height: 100%">
      <div class="bg-color deviceDetailContentHeight">
        <el-row class="point" style="padding-bottom: 10px;padding-top: 30px;padding-left:100px;min-height: 15px;  font-size: 18px;">
          <el-col :key="item.id" :span="15"  v-for="item in historyData"  style="text-align:left;font-size: 15px">
                <span v-if="item.pointCode !== 'av1' && item.pointCode !== 'ai1' && item.pointCode !== 'lv1'
                      && item.pointCode !== 'bv2' && item.pointCode !== 'bi2' && item.pointCode !== 'lv2'
                      && item.pointCode !== 'cv3' && item.pointCode !== 'ci3' && item.pointCode !== 'lv3'">
                  <span class="value" >{{ item.pointName }}:</span><span style="color: rgba(6,191,211,1);margin-left: 10px; font-weight: bold;">{{ item.pointValueName }}</span>
                </span>
          </el-col>


        </el-row>
      </div>
    </el-col>
    <el-col :lg="15" :md="24" style="height: 100%">
      <div class="e-chart bg-color deviceDetailContentHeight">
        <el-row
          style="border-bottom: 1px solid rgba(41, 155, 255, 0.3);padding-bottom: 8px;margin-top: 10px;min-height: 160px;">
          <el-col :lg="6" :md="6" :sm="6" class="text-center">
            <div class="labelName" style="color: #FFF600;">A相</div>
          </el-col>
          <div :key="item.id" v-for="item in historyData">
            <el-col :lg="6" :md="6" :sm="6" :xs="24"
                    v-if="item.pointCode === 'av1' || item.pointCode === 'ai1' || item.pointCode === 'sp1' || item.pointCode === 'lv1'">
              <point-gauge :data="item" :extend-data="extendData"></point-gauge>
            </el-col>
          </div>
        </el-row>

        <el-row
          style="border-bottom: 1px solid rgba(41, 155, 255, 0.3);padding-bottom: 8px;margin-top: 30px;min-height: 160px;">
          <el-col :lg="6" :md="6" :sm="6" class="text-center">
            <div class="labelName" style="color: #64DA64;">B相</div>
          </el-col>
          <div :key="item.id" v-for="item in historyData">
            <el-col :lg="6" :md="6" :sm="6" :xs="24"
                    v-if="item.pointCode === 'bv2' || item.pointCode === 'bi2' || item.pointCode === 'sp2' || item.pointCode === 'lv2'">
              <point-gauge :data="item" :extend-data="extendData"></point-gauge>
            </el-col>
          </div>
        </el-row>

        <el-row
          style="padding-bottom: 8px;margin-top: 30px;min-height: 160px;">
          <el-col :lg="6" :md="6" :sm="6" class="text-center">
            <div class="labelName" style="color: #FF4949;">C相</div>
          </el-col>
          <div :key="item.id" v-for="item in historyData">
            <el-col :lg="6" :md="6" :sm="6" :xs="24"
                    v-if="item.pointCode === 'cv3' || item.pointCode === 'ci3' || item.pointCode === 'sp3' || item.pointCode === 'lv3'">
              <point-gauge :data="item" :extend-data="extendData"></point-gauge>
            </el-col>
          </div>
        </el-row>

      </div>
    </el-col>
  </el-row>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import {getHistoryByDevicePoint} from "@/network/measuring-point-history";
import PointGauge from "@/components/device_details/comp/PointGauge";

export default {
  name: "ElectricityMeter",
  // eslint-disable-next-line vue/no-unused-components
  components: {CloudedGlass, PointGauge},
  props: ['deviceInfo', 'alarmInfoList'],
  data() {
    return {
      title: {
        show: false
      },
      extendData: {},
      pointCodes: [],
      historyData: [],
    }
  },
  mounted() {
    this.getPointData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getElectricityMeterData:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getElectricityMeterData')
  },
  methods: {
    getPointData() {
      getHistoryByDevicePoint({
        deviceId: this.deviceInfo.id,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          this.historyData = res.data.filter(item => item.pointName && item.pointName.trim() !== '');
        }
      })
    }
  }
}
</script>

<style scoped>
.device-img, .device-img img {
  margin: 0 auto 0 auto;
  width: 80%;
  max-width: 371px;
}

.device-img img {
  margin-top: 50px;
}

/*测点详情*/
.cross-line {
  width: 0;
  margin-top: 50px;
  height: 200px;
  border: 1px solid rgba(41, 155, 255, 0.2);
}
.value{
  color: rgba(141,176,203,1);

}


.point .name {
  font-size: 20px;
  font-weight: 400;
  line-height: 19px;
  color: #299BFF;
  border-left: 1px solid rgba(41, 155, 255, 0.2);
}

.e-chart {
  padding: 10px 8% 0 8%;
}

.labelName {
  width: 24px;
  margin: auto;
  font-size: 1rem;
  font-weight: 600
}
</style>
